import { ClientConfig, DEFAULT_CLIENT_CONFIG } from './config.base';
import { navigationRoutes as BaseLinks, RouteParams } from './links.base';

export const CLIENT_CONFIG: ClientConfig = {
  clientName: 'machinemaxuae',
  ...DEFAULT_CLIENT_CONFIG,
  logo: {
    lightLogo: 'assets/machinemaxuae/light-logo.png',
    darkLogo: 'assets/machinemaxuae/dark-logo.png',
    alt: 'MachineMaxUAE',
    width: '180px',
    height: '26px',
    loginPageWidth: '120px',
    loginPageHeight: '18px',
  },
  showCustomLoginPage: true,
};

export const navigationRoutes: RouteParams[] = CLIENT_CONFIG.allowedRoutes.map((x) => BaseLinks[x]);
